module.exports = __webpack_public_path__ + "img/奥康.cbbafb1b.png";